import { lazy } from 'react';

const Screen = {
  Content: lazy(
    () => import('components/direct-sales/psr-entry/components/PsrContent')
  ),
  RightSidebar: lazy(
    () => import('components/direct-sales/psr-entry/components/PsrSideBarRight')
  ),
  Header: lazy(
    () => import('components/direct-sales/psr-entry/components/PsrHeader')
  )
};

export default Screen;
